'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');
var ColorImage = require('../common/ColorImage');

var NavigationBar = React.createClass({
  render: function () {
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var isLightColor = util.Color.isLight(bgColor);

    var color = styleHelper.getPropertyValue(this.props, propConst.FOREGROUND_COLOR);
    if (this.props.IsAutoTextColor) {
      if (isLightColor) {
        color = '#000'
      } else {
        color = '#fff'
      }
    }
    return (
      <div
        className="navigation-bar-content"
        style={{
        width: '100%',
        height: '100%',
        backgroundColor: bgColor
      }}>
        <ColorImage {...{
          src: assetsHelper.getComponentAsset('navigationbar'),
          height: 48,
          width: styleHelper.getWidth(this.props),
          color: color
        }} style={{
          width: styleHelper.getWidth(this.props),
          height: 48,
          position: 'absolute',
          top: (styleHelper.getHeight(this.props) - 48) / 2
        }}/>
      </div>
    )
  }
});

module.exports = NavigationBar;


// WEBPACK FOOTER //
// ./src/views/Components/NavigationBar.jsx